export default "__VITE_ASSET__b03249f7__"